import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import LinkControls from '@components/link';
import ClassDropdown, { getBlockClassNames } from '@components/class-dropdown';
import Label from '@components/block-label';
import { DEFAULT_CSS_CLASS } from '@constants';
import {
  useBlockProps,
  useInnerBlocksProps,
  __experimentalBlockVariationPicker as BlockVariationPicker,
  store as blockEditorStore,
} from '@wordpress/block-editor';
import classnames from 'classnames';

import './editor.scss';
import variations from './variations/index';
import { buttonIcon } from './icons';

const {
  i18n: { __ },
  data: { useDispatch, useSelect },
  blocks: { createBlocksFromInnerBlocksTemplate },
} = wp;

const VariationPicker = ({ clientId, setAttributes }) => {
  const { replaceInnerBlocks } = useDispatch(blockEditorStore);
  // when skip, first variant will be set as a default
  const defaultVariation = variations[0];
  return (
    <BlockVariationPicker
      variations={variations}
      label={__('Button', 'b3rg')}
      instructions={__('Choose a variation to start with.', 'b3rg')}
      icon={buttonIcon}
      onSelect={(variation = defaultVariation) => {
        if (variation.attributes) {
          setAttributes(variation.attributes);
        }
        if (variation.innerBlocks) {
          replaceInnerBlocks(
            clientId,
            createBlocksFromInnerBlocksTemplate(variation.innerBlocks),
            true,
          );
        }
      }}
      allowSkip
    />
  );
};

const DisplayBlocks = (props) => {
  const { attributes, setAttributes, context } = props;
  const { blockVisibility, allowedBlocks, blockClassNames, label } = attributes;
  const defaultBlockCssClass = DEFAULT_CSS_CLASS.BUTTON;
  const defaultBlockDynamicCssClass = `${defaultBlockCssClass}`;
  const classNames = getBlockClassNames(blockClassNames);
  const disableNestedLink = context['b3rg/disableNestedLink'];

  const blockProps = useBlockProps({
    className: classnames({
      [`${defaultBlockCssClass}`]: true,
      [`${defaultBlockDynamicCssClass}`]: defaultBlockDynamicCssClass,
      [`${classNames}`]: classNames,
      disable: !blockVisibility,
    }),
  });
  const { children, ...innerBlocksProps } = useInnerBlocksProps(blockProps, {
    allowedBlocks,
  });

  return (
    <>
      <InspectorTabs>
        <InspectorControlsGeneral>
          <Label {...{ label, setAttributes }} />
          <Visibility {...{ blockVisibility, setAttributes }} />
          {!disableNestedLink && (
            <LinkControls {...{ attributes, setAttributes }} />
          )}
        </InspectorControlsGeneral>
        <InspectorControlsAppearance>
          <ClassDropdown
            {...{
              blockClassNames,
              setAttributes,
              blockClassPrefix: defaultBlockCssClass,
            }}
          />
        </InspectorControlsAppearance>
      </InspectorTabs>
      <div {...innerBlocksProps}>
        {!disableNestedLink ? (
          <span className={`${defaultBlockCssClass}__link`}>{children}</span>
        ) : (
          children
        )}
      </div>
    </>
  );
};

export default function Edit(props) {
  const { clientId } = props;
  const hasInnerBlocks = useSelect(
    (select) => select(blockEditorStore).getBlocks(clientId).length > 0,
    [clientId],
  );
  const Component = hasInnerBlocks ? DisplayBlocks : VariationPicker;

  return <Component {...props} />;
}
